export const estonianCountryMappings: { [key: string]: string } = {
  'Ameerika Ühendriigid': 'USA',
  'Araabia Ühendemiraadid': 'AÜE',
  'Lõuna-Aafrika Vabariik': 'LAV',
  'Kesk-Aafrika Vabariik': 'KAV',
  Colombia: 'Kolumbia',
  'Saudi Araabia': 'KSA',
  Suurbritannia: 'Ühendkuningriik, Inglismaa, Wales, Šotimaa, Põhja-Iirimaa',
  Svaasimaa: 'eSwatini Kuningriik',
  Gruusia: 'Georgia',
  Myanmar: 'Birma',
};

export const russianCountryMappings: { [key: string]: string } = {
  'Соединенные Штаты Америки': 'США',
  'Объединенные Арабские Эмираты': 'ОАЭ',
  ЮАР: 'Южно-Африканская Республика',
  Великобритания: 'Соединенное Королевство, Англия, Уэльс, Шотландия, Северная Ирландия',
  'Центрально-Африканская Республика': 'ЦАР',
  Свазиленд: 'Королевство Эсватини',
};
